import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import TrackableLink from 'views/components/TrackableLink/TrackableLink';

export default connect(null, { push })(TrackableLink);
